import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Box from '@mui/material/Box';

const FONT_FAMILY = 'Material Symbols Rounded';

const buildBaseSx = (size, weight) => ({
    fontFamily: FONT_FAMILY,
    fontWeight: 'normal',
    fontStyle: 'normal',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
    textTransform: 'none',
    letterSpacing: 'normal',
    wordWrap: 'normal',
    whiteSpace: 'nowrap',
    direction: 'ltr',
    WebkitFontSmoothing: 'antialiased',
    fontSize: size,
    fontVariationSettings: `'FILL' 0, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`,
});

function MaterialSymbol({
    name,
    size = 24,
    weight = 300,
    sx = null,
    className = '',
    ...rest
}) {
    const composedSx = sx ? [buildBaseSx(size, weight), sx] : buildBaseSx(size, weight);

    return (
        <Box
            component="span"
            aria-hidden="true"
            className={clsx('notranslate', className)}
            sx={composedSx}
            {...rest}
        >
            {name}
        </Box>
    );
}

MaterialSymbol.propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

export default MaterialSymbol;
